module.exports = __webpack_public_path__ + "img/engneer_economy.mars.d42567b.png";